import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import ViewData from "./ViewData";

import { DocumentListContainer } from "./DocumentList.styled";

import "./DocumentList.scss";
/**
 * Document List,
 * Path - /analyticalNotes
 * @see See [Document Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2920611841/Centre+products+list)
 * @component
 */
const DocumentList = (props) => {
  const { t, entityId, entityType, entityData } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  return (
    <DocumentListContainer className="center-products-list">
      <ViewData
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        entityId={entityId}
        entityType={entityType}
        entityData={entityData}
      />
    </DocumentListContainer>
  );
};

DocumentList.propTypes = {
  t: PropTypes.func.isRequired,
  isHeader: PropTypes.bool,
};

DocumentList.defaultProps = {
  isHeader: true,
};

export default withTranslation()(DocumentList);
